// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #ffffff;
  display: grid;
  grid-template-rows: auto 1fr;
}

.dashboard-header {
  padding: 1.5rem;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo {
  height: 60px;
  width: auto;
  filter: brightness(1.2);
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.brand-text {
  display: flex;
  flex-direction: column;
}

.brand-text h1 {
  font-size: 1.8rem;
  margin: 0;
  font-weight: 700;
  background: linear-gradient(45deg, #ffffff, #e0e0e0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.brand-text h2 {
  font-size: 1rem;
  margin: 0;
  color: #888;
}

.dashboard-content {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 2rem;
  padding: 2rem;
}

.dashboard-sidebar {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 1.5rem;
  height: fit-content;
}

.dashboard-main {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.welcome-message {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 2rem;
  text-align: center;
  animation: fadeIn 0.5s ease-out;
}

.company-info h2 {
  font-size: 2.5rem;
  margin: 0;
  font-weight: 700;
  letter-spacing: 2px;
}

.company-info p {
  font-size: 1.2rem;
  color: #888;
  margin-top: 0.5rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-content {
    grid-template-columns: 1fr;
  }
  
  .logo-container {
    flex-direction: column;
    text-align: center;
  }
  
  .brand-text h1 {
    font-size: 1.5rem;
  }
}

/* Estilos para el indicador de estado del sistema */
.plan-status-placeholder {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.status-indicator {
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
  text-align: center;
  transition: all 0.3s ease;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.status-indicator.online {
  background-color: #28a745; /* Verde brillante */
  box-shadow: 0 0 15px rgba(40, 167, 69, 0.7);
}

.status-indicator.offline {
  background-color: #dc3545; /* Rojo de advertencia */
  box-shadow: 0 0 15px rgba(220, 53, 69, 0.7);
}

.last-seen {
  font-size: 0.9rem;
  color: #aaa;
  text-align: center;
}

.last-seen p {
  margin: 0.2rem 0;
}

.error-message {
  color: #ffc107; /* Amarillo/Naranja para errores */
  text-align: center;
  font-weight: bold;
} `, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAE9B,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EAEpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,kCAAkC;EAClD,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".dashboard-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  color: #ffffff;\n  display: grid;\n  grid-template-rows: auto 1fr;\n}\n\n.dashboard-header {\n  padding: 1.5rem;\n  background: rgba(0, 0, 0, 0.2);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.logo {\n  height: 60px;\n  width: auto;\n  filter: brightness(1.2);\n  transition: transform 0.3s ease;\n}\n\n.logo:hover {\n  transform: scale(1.05);\n}\n\n.brand-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.brand-text h1 {\n  font-size: 1.8rem;\n  margin: 0;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ffffff, #e0e0e0);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.brand-text h2 {\n  font-size: 1rem;\n  margin: 0;\n  color: #888;\n}\n\n.dashboard-content {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 2rem;\n  padding: 2rem;\n}\n\n.dashboard-sidebar {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 15px;\n  padding: 1.5rem;\n  height: fit-content;\n}\n\n.dashboard-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.welcome-message {\n  background: rgba(255, 255, 255, 0.1);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  padding: 2rem;\n  text-align: center;\n  animation: fadeIn 0.5s ease-out;\n}\n\n.company-info h2 {\n  font-size: 2.5rem;\n  margin: 0;\n  font-weight: 700;\n  letter-spacing: 2px;\n}\n\n.company-info p {\n  font-size: 1.2rem;\n  color: #888;\n  margin-top: 0.5rem;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-content {\n    grid-template-columns: 1fr;\n  }\n  \n  .logo-container {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .brand-text h1 {\n    font-size: 1.5rem;\n  }\n}\n\n/* Estilos para el indicador de estado del sistema */\n.plan-status-placeholder {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.status-indicator {\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-weight: bold;\n  text-align: center;\n  transition: all 0.3s ease;\n  color: #ffffff;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.status-indicator.online {\n  background-color: #28a745; /* Verde brillante */\n  box-shadow: 0 0 15px rgba(40, 167, 69, 0.7);\n}\n\n.status-indicator.offline {\n  background-color: #dc3545; /* Rojo de advertencia */\n  box-shadow: 0 0 15px rgba(220, 53, 69, 0.7);\n}\n\n.last-seen {\n  font-size: 0.9rem;\n  color: #aaa;\n  text-align: center;\n}\n\n.last-seen p {\n  margin: 0.2rem 0;\n}\n\n.error-message {\n  color: #ffc107; /* Amarillo/Naranja para errores */\n  text-align: center;\n  font-weight: bold;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
